import { httpRequest } from "../../http";

export interface LastPerformanceImport {
    last_synced_at: string | null;
    status: string | null;
    job_id: number | null;
}

export class CommandGetLastPerformanceImport {
    async run(): Promise<LastPerformanceImport> {
        return await httpRequest<LastPerformanceImport>(
            `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/import-performance/last/`,
            { method: "GET" }
        );
    }
}
